import { h } from 'preact';
import { Icon } from 'components/icon/icon';
import './addons-and-settings.scss';
import { useContext, useEffect } from 'preact/hooks';
import { ApplicationContext } from 'contexts/use-application-setup';
import { redirectToDashboard } from 'helpers/redirect-to-dashboard';
import { headerStore } from 'global/header.store';
import { A11YIcon } from '@uw/icons';

export const AddonsAndSettings = () => {
  const { tunings } = useContext(ApplicationContext);

  const paths = {
    account: `/settings/general`,
    sites: `/widget/my-sites/p/1`,
    settings: `/widget/my-sites/p/1/site-details/settings?site=${tunings.site_name}`,
    addons: `/widget/my-sites/p/1/site-details/addons?site=${tunings.site_name}`,
  };

  useEffect(() => {
    headerStore.title.next(`Settings`);
  }, []);

  return (
    <div class="uwaw-settings__card">
      <div class="uwaw-settings__link-container">
        <div class="uwaw-settings__link-name">
          <Icon type="user" />
          Account settings
        </div>
        <a
          href="#"
          onClick={() => redirectToDashboard(paths.account)}
          aria-label="Open account section in the Userway dashboard in a new tab"
        >
          <Icon type="external-link-icon" />
        </a>
      </div>
      <div class="divider" />
      <div class="uwaw-settings__link-container">
        <div class="uwaw-settings__link-name">
          <Icon type="globe" />
          Sites
        </div>
        <a
          href="#"
          onClick={() => redirectToDashboard(paths.sites)}
          aria-label="Open sites section in the Userway dashboard in a new tab"
        >
          <Icon type="external-link-icon" />
        </a>
      </div>
      <div class="divider" />
      <div class="uwaw-settings__link-container">
        <div class="uwaw-settings__link-name">
          <A11YIcon height={20} width={20} />
          Widget settings
        </div>
        <a
          href="#"
          onClick={() => redirectToDashboard(paths.settings)}
          aria-label="Open settings section in the Userway dashboard in a new tab"
        >
          <Icon type="external-link-icon" />
        </a>
      </div>
      <div class="divider" />
      <div class="uwaw-settings__link-container">
        <div class="uwaw-settings__link-name">
          <Icon type="puzzle" />
          Addons
        </div>
        <a
          href="#"
          onClick={() => redirectToDashboard(paths.addons)}
          aria-label="Open addons section in the Userway dashboard in a new tab"
        >
          <Icon type="external-link-icon" />
        </a>
      </div>
    </div>
  );
};
